// Shared constants and formatting helpers for the Bookings pages.

export const PAYMENT_MODES = ['Cash', 'UPI', 'Online', 'Wallet'];
export const BOOKING_SOURCES = ['Calling', 'Khelomore', 'District', 'Hudle', 'Walk-in', 'WhatsApp', 'Online', 'App', 'Others'];

export const DATE_FILTER_OPTIONS = [
  { value: 'today', label: 'Today' },
  { value: 'yesterday', label: 'Yesterday' },
  { value: 'tomorrow', label: 'Tomorrow' },
  { value: 'this_week', label: 'This Week' },
  { value: 'this_month', label: 'This Month' },
  { value: 'this_year', label: 'This Year' },
  { value: 'custom', label: 'Custom Range' },
];

export const TIME_SLOTS = (() => {
  const slots = [];
  for (let hour = 6; hour <= 26; hour++) {
    for (let minute = 0; minute < 60; minute += 30) {
      const totalMinutes = hour * 60 + minute;
      const displayHour = Math.floor(totalMinutes / 60);
      const displayMinute = totalMinutes % 60;
      const finalHour = displayHour > 23 ? displayHour - 24 : displayHour;
      const ampm = finalHour < 12 ? 'AM' : 'PM';
      const displayHour12 = finalHour === 0 ? 12 : finalHour > 12 ? finalHour - 12 : finalHour;
      slots.push(`${String(displayHour12).padStart(2, '0')}:${String(displayMinute).padStart(2, '0')} ${ampm}`);
      if (displayHour >= 26) break;
    }
  }
  return slots;
})();

// Format date as "1st Mar", "2nd Apr" etc
export const formatShortDate = (dateStr) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  const day = date.getDate();
  const month = date.toLocaleString('en-US', { month: 'short' });
  const suffix = (day) => {
    if (day > 3 && day < 21) return 'th';
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  };
  return `${day}${suffix(day)} ${month}`;
};

// Format an ISO timestamp into "12 Jun 2026, 4:35 PM" (IST). Used for entry/capture time.
export const formatEntryDateTime = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '';
  return d.toLocaleString('en-IN', {
    day: 'numeric', month: 'short', year: 'numeric',
    hour: 'numeric', minute: '2-digit', hour12: true,
    timeZone: 'Asia/Kolkata',
  });
};

// Today's date (YYYY-MM-DD) in India time, independent of browser/server timezone
export const istToday = () => new Date().toLocaleDateString('en-CA', { timeZone: 'Asia/Kolkata' });

export const istDateOffset = (days) => {
  const base = new Date(`${istToday()}T00:00:00`);
  base.setDate(base.getDate() + days);
  return base.toLocaleDateString('en-CA');
};

// Extract a readable string from an API error (handles FastAPI/Pydantic 422 detail arrays)
export const apiErrMsg = (error, fallback) => {
  const d = error?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || (typeof e === 'string' ? e : JSON.stringify(e))).join(', ');
  if (d && typeof d === 'object') return d.msg || JSON.stringify(d);
  return fallback;
};

// Format time as "4pm", "10am" etc
export const formatShortTime = (timeStr) => {
  if (!timeStr) return '';
  const match = timeStr.match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);
  if (!match) return timeStr;
  const hour = parseInt(match[1]);
  const minute = match[2];
  const period = match[3].toLowerCase();
  if (minute === '00') {
    return `${hour}${period}`;
  }
  return `${hour}:${minute}${period}`;
};

// Normalize court names for consistency (e.g. "Court 2" -> "Court-2")
export const normalizeCourt = (court) => {
  if (!court) return court;
  if (['A1', 'A2'].includes(court.toUpperCase())) {
    return court.toUpperCase();
  }
  const match = court.match(/(?:court|Court)\s*[-]?\s*(\d+)/i);
  if (match) {
    return `Court-${match[1]}`;
  }
  return court;
};
